import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { EmptyBranch } from "./EmptyBranch";
import { IModel } from "./BranchMast";
import { Search } from "../../shared/Search";
import { IBranchMast } from "../../models/BranchMast";
import { IPermissionProps } from "../../models/Login";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IBranchMast>, loading: boolean });
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const dt = useRef<any>(null);

    useEffect(() => {
        loadTableData();
    }, [globalFilter, props.reload]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Branch_Mast", "GET", null, `filter=${globalFilter}`, props.toast);
        if (response) {
            const data: Array<IBranchMast> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyBranch });
    };

    const openEdit = (rowDatauser: IBranchMast) => {
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage Branches</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );

    const actionBodyTemplate = (rowData: IBranchMast) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
            </div>
        );
    };

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="65vh"
                value={tableData.tableData}
                emptyMessage="No Branches found."
                header={header}
                loading={tableData.loading}
            >
                <Column field="branchName" header="Branch Name" sortable />
                <Column field="branchCode" header="Branch Code" sortable />
                <Column field="company_Name" header="Company Name" sortable />
                <Column field="brachDescription" header="Description" />
                <Column body={actionBodyTemplate} />
            </DataTable>
        </>
    );
}
